import React from 'react';
/*
import {
  hf,
  ht,
  f,
  cr,
  useGblz,
  a,
  ls,
  BoxC,
  IptC,
  LblC,
  LgnIdC,
  MsgC,
  RootC,
  GridC,
  TextC,
  _cv_31___Mz,
  _cv_40___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as LblC from "./_cccLblC";
import * as MsgC from "./_cccMsgC";
import * as LgnIdC from "./_ccmLgnIdC";
import * as RootC from "./_ccmRootC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as ht from './_ht';
import * as hf from './_hf';

import * as icm from './icm';
import IccvFtr from './IccvFtr';

let $_31r_fst = -1;
let $_31rs = [] as ht.ls;

let $idz = {
  id: '',
  pwd: '',
};

export const N = (pz: {
}) => {

  const _frcUdt = ls.frcUdt();
  const _gUserz = gs.useGblz('user');

  const _sPz = ls.usePz();

  const _udtThis = ls.udtThis();

  //hf.l(`icvLgnS10Rz 43: here`);
  React.useEffect(() => {
    //hf.l(`icvLgnS10Rz 45: here`);
    icm.setLgnAsync({
      frcUdt: _udtThis,
      atrAsync: async () => {
        //hf.l(`icvLgnS10Rz 49: here`);
        await _cv_31___Mz.load_31rLsAsync()
        .then((_ls: ht.ls) => {
          //hf.l(`icvLgnS10Rz 52: ${hf.s(_ls)}`);
          $_31rs = _ls;
          _udtThis();
        })
      }
    })
  }, []);

  //hf.l(`icvLgnS10Rz 60: ${hf.s(_gUserz.crt)}`);
  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        oClds: [

          cr.c(GridC.N, {
            key: -20,
            abtType: 'lgnCmnz',
            lineCs: [
              {
                cellCs: [
                ]
              },
              {
                boxStlz: a('f/n'),
                cellCs: [
                  {
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        abtType: 'lgnHdgStfz',
                        textz: {
                          pfx: `【${_gUserz.crt._20rz?._pfx ?? ''}】 施設予約管理【スタッフ用】`,
                        },
                      }),
                    ]
                  }
                ]
              },
              {
                boxStlz: a('f/n mv/4'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(MsgC.N, {
                        key: -10,
                        abtType: 'lgn1Cmnz',
                        cz: {
                          ls: [
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '▼',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: '登録したログインIDとパスワードを入力し、[ログイン] ボタンを押してください。',
                                },
                              }
                            },
                          ]
                        }
                      }),

                    ]
                  }
                ]
              },
              {
                boxStlz: a('f/n'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(LblC.N, {
                        key: -10,
                        abtType: 'vclStfz',
                        boxStlz: a('mb/1'),
                        lblCz: {
                          textz: {
                            pfx: '施設',
                            stlz: a('tc/gn7'),
                          },
                        },
                        cttCz: {
                          oClds: [
                            cr.c(IptC.S, {
                              key: -10,
                              cz: {
                                bEdit: true,
                                iptType: 'pcr',
                                ls: $_31rs,
                                vle: $_31r_fst,
                                onChg: (_dz: ht.dz) => {
                                  $_31r_fst = _dz.key;
                                }
                              }
                            })
                          ],
                        }
                      }),

                      cr.c(LgnIdC.N, {
                        key: -20,
                        cz: {
                          idz: $idz,
                          ccd: 'gn7',
                          grtCfmz: () => ({
                            cdn: `_10r_31r1f IN (${$_31r_fst}, 0) AND _10rt1100i = 20` 
                          }),
                          atrCfm: async (_dz: ht.dz) => {
                            const _31z = await _cv_31___Mz.load_31rDzAsync({
                              _31r_fst: $_31r_fst
                            });
                            await _gUserz.saveAsync({
                              _31rz: _31z._31rz,
                            });
                            const _40rz = await _cv_40___Mz.load_40rAzAsync({
                              _31r_fst: _gUserz.crt._31rz._fst,
                              _10r_key: _gUserz.crt._10rz._key,
                            })
                            await _gUserz.saveAsync({
                              _40rz: _40rz,
                            });
                            await _gUserz.saveAsync({
                              usrClr: 'gn',
                            });
                            cr.moveTo({
                              pageName: 'icvHomeS10Rz',
                            })
                          },
                        }
                      })

                    ]
                  }
                ]
              },
              {
                        boxStlz: a('f/n mv/4'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(BoxC.N, {
                        key: -10,
                        oClds: [
                          cr.c(TextC.N, {
                            key: -10,
                            textz: {
                              pfx: '※ パスワードが不明な場合は、システム管理者までお問い合わせください。',
                              stlz: a('ts/s'),
                            },
                          }),

                          cr.c(TextC.N, {
                            key: -30,
                            textz: {
                              pfx: '※ 本システムは、最新版の Chrome, Safari, Edge, FireFox にてご利用いただけます。',
                              stlz: a('ts/s'),
                            },
                          }),

                        ]
                      }),


                    ]
                  }
                ]
              },
              {
                cellCs: [
                ]
              },
            ]
          }),

          cr.c(IccvFtr, {
            key: -30,
          })

        ],
      },
    })
  );
};
